import './card.less'

import {Background, m, Picture} from '@codeurs/front'
import styled from '@emotion/styled'
import {ShareIcon} from 'assets/inline-icons'
import {HTMLProps} from 'react'
import {ImageType} from 'types'
import {style} from 'util/style'
import {Share} from '../partials/share'

const styles = style('card', [
  'title',
  'header',
  'headercol',
  'headerrow',
  'image',
  'category',
  'date',
  'image',
  'footer',
  'separator',
  'container',
  'shareicon',
  'downloadicon',
  'tag'
])

export const Card = styles.toElement<HTMLProps<HTMLDivElement>>('div')

type CardTitle = HTMLProps<
  | HTMLHeadingElement
  | ({as?: 'p'} & HTMLParagraphElement)
  | ({as?: 'h2' | 'h3' | 'h4'} & HTMLHeadingElement)
>

export const CardTitle = styles.title.toElement<CardTitle>(
  ({as: el, ...props}) => {
    const StyledElement: any = el || 'h2'
    return <StyledElement {...props} />
  }
)

export const CardContainer =
  styles.container.toElement<HTMLProps<HTMLHeadingElement>>('div')

export const CardCategory = styles.category.toElement<{
  color?: string
}>(({color, ...props}) => {
  const StyledDiv = styled('div')`
    &:before {
      background-color: ${color ? color : '#f57c00'};
    }
  `
  return <StyledDiv {...props} />
})

export const CardDate =
  styles.date.toElement<HTMLProps<HTMLTimeElement>>('time')
export const CardShareIcon = styles.shareicon.toElement<{
  copy: string
  url?: string
}>(({url = '#share', copy}) => (
  <div class={styles('share')}>
    <Share
      text={copy}
      url={(url.indexOf('http') !== 0 ? window.location.protocol : '') + url}
    >
      <ShareIcon className={styles.shareicon} />
    </Share>
  </div>
))
export const CardDownloadIcon = styles.downloadicon.toElement<{
  image: ImageType
  url?: string
  ariaLabel?: string
}>(({image, url = '#download', ariaLabel = 'Download'}) => (
  <a
    href={url}
    target="_blank"
    aria-label={ariaLabel}
    className={styles.downloadicon}
  >
    <Picture {...image} alt={image.alt} />
  </a>
))

export const CardImage = styles.image.toElement<ImageType>(image => (
  <div class={styles.image()}>
    <Background
      img={image}
      alt={image.alt || image.title?.replace(/^.*[\\/]|(\.[^/.]+$)/g, '') || ''}
      class={styles.image('bg').toString()}
    />
  </div>
))

export const CardHeader =
  styles.header.toElement<HTMLProps<HTMLDivElement>>('header')
export const CardHeaderCol =
  styles.headercol.toElement<HTMLProps<HTMLDivElement>>('div')
export const CardHeaderRow =
  styles.headerrow.toElement<HTMLProps<HTMLDivElement>>('div')
export const CardFooter =
  styles.footer.toElement<HTMLProps<HTMLDivElement>>('footer')
export const CardTag = styles.tag.toElement<HTMLProps<HTMLSpanElement>>('span')
export const CardSeparator =
  styles.separator.toElement<HTMLProps<HTMLSpanElement>>('span')
